import type { ReceiptTemplate } from '../schema';

export const discountTireTemplate: ReceiptTemplate = {
  id: 'discount-tire',
  name: 'Discount Tire Receipt',
  brand: 'DISCOUNT TIRE',
  description: 'Discount Tire service receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'dt-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/discount-tire.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: ['STORE #4892', '1200 DARK AVENUE', 'MONSTERVILLE, CA 94608', '(510) 555-0127'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dt-vehicle',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'customer', label: 'Customer:', value: 'JOHN DOE' },
          { id: 'vehicle', label: 'Vehicle:', value: '2022 HONDA ACCORD' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'invoice', label: 'Invoice:', value: '847291' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dt-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MICHELIN DEFENDER 225/65R17', quantity: '4', price: '189.99', sku: '' },
          { id: '2', name: 'MOUNTING & BALANCE', quantity: '4', price: '25.00', sku: '' },
          { id: '3', name: 'VALVE STEMS', quantity: '4', price: '3.99', sku: '' },
          { id: '4', name: 'TIRE DISPOSAL FEE', quantity: '4', price: '3.50', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dt-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '889.92', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '73.42', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '963.34', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dt-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'dt-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'FREE TIRE ROTATION\nFOR LIFE OF TIRES\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

